import { Box, Stack } from '@mui/material';

const TextWithIcon = ({ label, Icon }: { label: string, Icon: React.ElementType }) => (
  <Box>
    <Stack direction="row" alignItems="center" spacing={1}>
      <Icon fontSize="small" />
      <Box>{label}</Box>
    </Stack>
  </Box>
);

export default TextWithIcon;
